import { NumericTextBox } from "@progress/kendo-react-inputs";

export default function CategoryBudgetSettings({
  draft,
  onBudgetChange,
  onDragStart,
  onDrop,
  orderedCategories,
  t = {}
}) {
  return (
    <section className="panel">
      <div className="section-heading">
        <div>
          <p className="eyebrow">{t.budgetsAndOrder || "Budgets and order"}</p>
          <h3>{t.categoryLimits || "Category limits"}</h3>
        </div>
        <span className="muted">{t.dragCategories || "Drag categories to reorder"}</span>
      </div>
      <div className="category-settings-list">
        {orderedCategories.map((category) => (
          <div
            className="category-settings-row"
            draggable
            key={category.value}
            onDragOver={(event) => event.preventDefault()}
            onDragStart={() => onDragStart(category.value)}
            onDrop={() => onDrop(category.value)}
          >
            <div className="category-settings-title">
              <span className={`k-icon ${category.icon}`} style={{ color: category.color }} />
              <strong>{category.text}</strong>
            </div>
            <NumericTextBox
              value={draft.categoryBudgets[category.value]}
              min={0}
              format="n2"
              onChange={(event) => onBudgetChange(category.value, event.value)}
            />
          </div>
        ))}
      </div>
    </section>
  );
}
